export class PersonNameInput {
    firstName: string;
    surName?: string;
}
